import { MapPin } from "lucide-react";
import { SITE } from "@/data/site";
import { getAreas } from "@/data/areas";
import { getAreaFaqsGeneral } from "@/data/faqs";
import { useLang } from "@/lib/i18n";
import AreaCard from "@/components/site/AreaCard";
import FloridaMap from "@/components/site/ServiceAreaMap";
import QuoteForm from "@/components/site/QuoteForm";
import FAQ from "@/components/site/FAQ";
import ReadyCTA from "@/components/site/ReadyCTA";

export default function ServiceAreas() {
  const { t, lang } = useLang();
  const AREAS = getAreas(lang);
  const FAQS = getAreaFaqsGeneral(lang);

  return (
    <>
      <section data-testid="areas-hero" className="relative bg-brand-navy-dark text-white overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={SITE.trailerImage}
            alt=""
            aria-hidden="true"
            className="w-full h-full object-cover"
            style={{ filter: "blur(3px) brightness(0.72) saturate(1.1)" }}
          />
          <div className="absolute inset-0 bg-gradient-to-br from-brand-navy-dark/78 via-brand-navy-dark/62 to-slate-900/78" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(255,191,0,0.12)_0%,transparent_60%)]" />
        </div>
        <div className="absolute -top-32 -right-24 w-[480px] h-[480px] rounded-full bg-brand-yellow/20 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-32 -left-24 w-[420px] h-[420px] rounded-full bg-brand-navy-light/25 blur-3xl pointer-events-none" />
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-yellow/70 to-transparent" />
        <div className="relative container-max py-16 sm:py-24">
          <div className="inline-flex items-center gap-2 rounded-full bg-brand-yellow text-slate-900 px-3.5 py-1.5 text-xs font-bold tracking-wide shadow-lg shadow-yellow-300/20">
            <MapPin size={14} />
            {t.areas.heroEyebrow}
          </div>
          <h1
            className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight max-w-3xl text-balance"
            style={{ textShadow: "0 2px 16px rgba(0,0,0,0.5)" }}
          >
            {t.areas.heroTitle}
          </h1>
          <p
            className="mt-5 text-white/95 text-lg max-w-2xl leading-relaxed"
            style={{ textShadow: "0 1px 8px rgba(0,0,0,0.45)" }}
          >
            {t.areas.heroSub}
          </p>
        </div>
      </section>

      {/* Map (left) + Form (right) */}
      <section className="section-padding bg-[radial-gradient(ellipse_at_top,#EFF6FF_0%,#F8FAFC_50%,#F1F5F9_100%)]">
        <div className="container-max grid lg:grid-cols-[1.15fr_1fr] gap-6">
          <FloridaMap />
          <QuoteForm sourcePage="service-areas" />
        </div>
      </section>

      {/* County cards */}
      <section className="section-padding bg-white">
        <div className="container-max">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 max-w-2xl mb-10">
            {t.areas.pickCounty}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {AREAS.map((a) => (
              <AreaCard key={a.slug} area={a} />
            ))}
          </div>
        </div>
      </section>

      <FAQ items={FAQS} eyebrow={lang === "es" ? "Cobertura · FAQ" : "Coverage · FAQ"} />

      <ReadyCTA />
    </>
  );
}
